import {
  BoxProps,
  Flex,
  InputGroup,
  InputProps,
  InputRightElement,
  Tag,
  TagCloseButton,
  TagLabel,
} from '@chakra-ui/react';
import { forwardRef } from 'react';
import IconButton from '~/components/IconButton';
import Input from '~/components/Input';
import { TagSelect, TagSelectProps } from '~/components/TagSelect';
import { SearchIcon } from '~/components/icons';

type ContainerProps = TagSelectProps & Omit<BoxProps, 'onChange'>;
interface Props extends ContainerProps {
  inputProps?: InputProps;
  children: React.ReactNode;
}

export const RecentContentFiltersBarTagSelect = forwardRef<
  HTMLDivElement,
  Props
>(({ inputProps = {}, ...containerProps }, ref) => (
  <TagSelect ref={ref} {...containerProps}>
    {({
      tags,
      value,
      maxCharacters,
      handleChange,
      handleKeyDown,
      handleSubmit,
      handleRemove,
    }) => (
      <>
        <InputGroup marginBottom={2}>
          <Input
            backgroundColor="white"
            data-testid="tag-select-input"
            maxLength={maxCharacters}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            placeholder="Filter by hashtag or handle"
            value={value}
            {...inputProps}
          />
          <InputRightElement marginRight={0}>
            <IconButton
              aria-label="Confirm"
              fontSize="20px"
              icon={<SearchIcon />}
              isRound
              height="auto"
              onClick={handleSubmit}
              variant="ghost"
            />
          </InputRightElement>
        </InputGroup>

        <Flex flexWrap="wrap" marginX={-1}>
          {tags.map((tag) => (
            <Tag
              borderRadius={9999}
              colorScheme="primary"
              key={tag}
              marginX={1}
              marginBottom={2}
              paddingX={4}
              data-testid={tag}
            >
              <TagLabel>{tag}</TagLabel>
              <TagCloseButton
                data-testid={`remove-${tag}`}
                onClick={() => handleRemove(tag)}
                opacity={1}
                sx={{ svg: { width: 4, height: 4 } }}
              />
            </Tag>
          ))}
        </Flex>
      </>
    )}
  </TagSelect>
));
